import { IoLocationOutline } from 'react-icons/io5';

import MapV1 from '../../assets/svg/MapV1.svg';
import { AnswersState } from '../../redux/Slices/QuestionsSlice';
import { Question } from '../../redux/Slices/StartTestSlice/newTemplete';
import { getItem } from '../../utils/storage';

type QuestionOverView = {
  questionsList: Question[];
  userAnswers: AnswersState;
  count: number;
  navigation: boolean;
  strikedOutOptions: [];
  hadleQuestionJump: (number: number) => void;
};

const QuestionsOverView = ({
  questionsList,
  userAnswers,
  count,
  navigation,
  hadleQuestionJump
}: QuestionOverView) => {
  return (
    <div className='scroll4 overflow-auto'>
      <div
        style={{
          boxShadow: navigation ? 'none' : '0px 0px 10px 2px #00000026'
        }}
        className={`${
          navigation
            ? ''
            : 'xl:[50%] mx-auto mb-4 mt-11 w-[90%] rounded-xl p-9 md:w-[70%] lg:w-[60%] 2xl:w-[45%]'
        }`}
      >
        <div
          className={`${
            navigation
              ? 'mx-7 justify-center border-y py-4'
              : 'justify-between border-b'
          } mb-3 flex gap-8 border-[#a1a0a0] pb-4 font-normal`}
        >
          {navigation ? (
            <div className='flex cursor-text items-center gap-[10px] text-sm'>
              <img src={MapV1} alt='map' />
              Current
            </div>
          ) : (
            <div className='font-araboto flex items-center text-base font-semibold'></div>
          )}
          <div className='flex gap-4'>
            <div className='flex cursor-text items-center  gap-[10px] text-sm'>
              <div className='mr-1 h-4 w-4 border border-dashed border-beta'></div>
              Unanswered
            </div>
            <div className='flex cursor-text items-center gap-[10px] whitespace-nowrap text-sm'>
              <div className='mr-1 h-4 w-4 border border-solid bg-primary'></div>
              Answered
            </div>
          </div>
        </div>
        <div
          className={`flex flex-wrap justify-center ${
            navigation ? 'px-6' : 'gap-4 px-0'
          } max-h-36 pt-[15px]`}
        >
          {questionsList?.map((question, index) => {
            const matchedQuestion = userAnswers[question?.sectionId]?.find(
              (item: any) => item.questionId === question.id
            );
            return (
              <div key={question.id}>
                <button
                  className={`${
                    navigation ? 'h-8 w-8' : 'h-10 w-10'
                  } relative mx-2 my-3 flex items-center justify-center   font-normal ${
                    matchedQuestion
                      ? 'bg-primary text-[#FDFBF9]'
                      : 'text-primaryColor border border-dashed border-beta text-primary hover:bg-lightGrey'
                  } `}
                  onClick={() => {
                    hadleQuestionJump(index);
                  }}
                >
                  <p
                    className={`${navigation ? 'text-lgx' : 'text-2xl'} ${
                      count === index && getItem('isFocused') ? 'underline' : ''
                    }`}
                  >
                    {index + 1}
                  </p>
                  {count === index && navigation && (
                    <div className='absolute -top-[70%] flex justify-center text-black'>
                      <IoLocationOutline size={20} />
                    </div>
                  )}
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default QuestionsOverView;
